import Ajax from '@/lib/ajax'
import { AxiosInstance } from 'axios'
import appconst from '@/lib/appconst'
export default {
  getPermissions(providerName: string, providerKey: string) {
    return Ajax.get(
      `api/abp/permissions?providerName=${providerName}&providerKey=${providerKey}`,
      {
        baseURL: appconst.token_root,
      }
    )
  },
  putPermissions(
    providerName: string,
    providerKey: string,
    permissions: any[]
  ) {
    return Ajax.put(
      `api/abp/permissions?providerName=${providerName}&providerKey=${providerKey}`,
      {
        permissions: permissions,
      },
      {
        baseURL: appconst.token_root,
      }
    )
  },
  getConfig() {
    return Ajax.get(`/api/abp/application-configuration`, {
      baseURL: appconst.token_root,
    })
  },
}
